import { render } from "./TemplateEighteen.vue?vue&type=template&id=164df6c7"
import script from "./TemplateEighteen.vue?vue&type=script&lang=js"
export * from "./TemplateEighteen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__